export const BANKBRANCH_LOADING = "BANKBRANCH_LOADING";
export const BANKBRANCH_RESET = "BANKBRANCH_RESET";
export const GET_BANKBRANCH = "GET_BANKBRANCH";
export const GET_BANKBRANCH_SUCCESS = "GET_BANKBRANCH_SUCCESS";
export const GET_BANKBRANCH_FAIL = "GET_BANKBRANCH_FAIL";
export const DELETE_BANKBRANCH = "DELETE_BANKBRANCH"
export const DELETE_BANKBRANCH_SUCCESS = "DELETE_BANKBRANCH_SUCCESS"
export const DELETE_BANKBRANCH_FAIL = "DELETE_BANKBRANCH_FAIL"
export const UPDATE_BANKBRANCH = "UPDATE_BANKBRANCH"
export const UPDATE_BANKBRANCH_SUCCESS = "UPDATE_BANKBRANCH_SUCCESS"
export const UPDATE_BANKBRANCH_FAIL = "UPDATE_BANKBRANCH_FAIL"
export const ADD_NEW_BANKBRANCH = "ADD_NEW_BANKBRANCH"
export const ADD_BANKBRANCH_SUCCESS = "ADD_BANKBRANCH_SUCCESS"
export const ADD_BANKBRANCH_FAIL = "ADD_BANKBRANCH_FAIL"